import { CreditCard, Timer, HandWaving, WhatsappLogo, Check, Star } from "@phosphor-icons/react";
import HomeVideo from "./HomeVideo";
import { HOME_VIDEO_PLAY_EVENT } from "./homeVideoConfig";
import "./home.css";
import "./HomeHero.css";

/*
 * Hero — two columns on desktop: copy (overline → display headline with one
 * mint marker stroke → sub → CTAs → trust) on the reading side, the demo
 * video on a tinted stage with floating proof badges on the other. Mobile
 * stacks copy → video. The video explains the product; the badges and
 * hand-drawn hint pull the eye to the play button.
 */

const TRUST = [
  { icon: CreditCard, label: "ללא כרטיס אשראי" },
  { icon: Timer, label: "הקמה תוך 3 דקות" },
  { icon: HandWaving, label: "ביטול בכל עת" },
];

function MarkerStroke() {
  return (
    <svg viewBox="0 0 200 10" preserveAspectRatio="none" aria-hidden="true">
      <path
        d="M3 7 C 55 2, 145 2, 197 6"
        fill="none"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
      />
    </svg>
  );
}

function HomeHero() {
  const playVideo = (e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent(HOME_VIDEO_PLAY_EVENT));
  };

  return (
    <section id="hero" className="home-section home-section--gray hhero" aria-labelledby="hhero-title">
      <div className="hhero-wash" aria-hidden="true" />
      <div className="home-shape home-shape--blob hhero-shape-blob" aria-hidden="true" />
      <div className="home-shape home-shape--blob hhero-shape-blob2" aria-hidden="true" />
      <div className="home-shape home-shape--ring hhero-shape-ring" aria-hidden="true" />
      <div className="home-shape home-shape--dot hhero-shape-dot" aria-hidden="true" />
      <div className="home-shape home-shape--bubble hhero-shape-bubble" aria-hidden="true" />
      <div className="home-shape home-shape--square hhero-shape-square" aria-hidden="true" />

      <div className="home-container hhero-inner">
        <div className="hhero-copy">
          <h1 id="hhero-title" className="home-display hhero-title home-rise home-rise--2">
            פחות ניהול
            <br />
            <span className="home-mark">
              יותר טיפול
              <MarkerStroke />
            </span>
          </h1>

          <p className="hhero-sub home-rise home-rise--3">
            יומן חכם, תזכורות SMS, תיק מטופל, סיכומי טיפול עם AI, חשבוניות וטפסים
            דיגיטליים — במערכת אחת מאובטחת שנבנתה למטפלים בישראל.
          </p>

          <div className="hhero-actions home-rise home-rise--4">
            <a href="#contact" className="home-btn hhero-btn hhero-btn--primary">
              <span className="hhero-btn-label">התחילו 30 ימי ניסיון חינם</span>
              {/* Mobile only: compact trust line replaces the trust strip below */}
              <span className="hhero-btn-note hhero-m-only" aria-hidden="true">
                {TRUST.map((item) => item.label).join(" · ")}
              </span>
            </a>
            <a href="#features" className="home-btn hhero-btn hhero-btn--glass" onClick={playVideo}>
              צפו בסיור של 4 דקות
            </a>
          </div>

          <ul className="hhero-trust hhero-d-only home-rise home-rise--5">
            {TRUST.map((item) => {
              const Icon = item.icon;
              return (
                <li key={item.label}>
                  <Icon size={18} weight="regular" aria-hidden="true" />
                  <span>{item.label}</span>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="hhero-media home-rise home-rise--3">
          <div className="hhero-stage">
            <HomeVideo />

            {/* Floating proof badges (desktop) */}
            <div className="hhero-badge hhero-badge--wa hhero-d-only" aria-hidden="true">
              <span className="hhero-badge-icon hhero-badge-icon--wa">
                <WhatsappLogo size={16} weight="fill" />
              </span>
              <span className="hhero-badge-text">
                <b>דנה לוי</b>
                <small>
                  <Check size={11} weight="bold" /> אישרתי הגעה · 10:00
                </small>
              </span>
            </div>

            <div className="hhero-badge hhero-badge--rating hhero-d-only" aria-hidden="true">
              <span className="hhero-badge-stars">
                {[0, 1, 2, 3, 4].map((i) => (
                  <Star key={i} size={12} weight="fill" />
                ))}
              </span>
              <span className="hhero-badge-text">
                <b>4.9 / 5</b>
                <small>+650 מטפלים כבר איתנו</small>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeHero;
